<template>
  <FieldSingleSelectOptions v-model="internalField.customFieldOptions" :error="optionsErrors" />
</template>

<script setup lang="ts">
import { toRef, Ref } from 'vue'
import { useVModel } from '@vueuse/core'
import FieldSingleSelectOptions from '@/components/Fields/fieldTypeComponents/FieldSingleSelectOptions.vue'
import { useGraphQlError } from '@/composables/errors'
import { CustomField } from '@/components/Fields/dataObjects/CustomField'

// This is a duplicate of Props from CustomFieldContent.vue as using imported interfaces do not work and will be fixed
// in vue.js 3.3.3
interface Props {
  field: CustomField
  validationErrors?: Object
  loading: boolean
}

const emits = defineEmits(['update:field'])

const props = withDefaults(defineProps<Props>(), {
  validationErrors: () => ({}),
})

const errors = toRef(props, 'validationErrors')

const optionsErrors = useGraphQlError(errors, 'options')

const internalField: Ref<CustomField> = useVModel(props, 'field', emits)
</script>

<style scoped lang="scss">
.tag-width-constrained {
  display: inline-flex;
  max-width: 100%;

  .tag-value {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .tag-delete {
    flex-shrink: 0;
  }
}

.has-error .help-block {
  background: none;
  color: rgb(235 46 46);
  padding: 0;

  &:before {
    content: '';
  }
}

:deep(.has-error .form-control) {
  border: 1px solid rgb(235 46 46) !important;
}

.control-label {
  font-size: 0.875rem;
  font-weight: 500;
}

.has-error .control-label {
  color: initial;
}
</style>
